module.exports = __webpack_public_path__ + "img/heating.e5ae14ef.png";